<template>
    <div class="shop-checkin-container">
        <!-- 步骤指引区域 -->
        <div class="steps-container">
            <!-- 第一步 -->
            <div class="step-section">
                <div class="step-title">
                    <span class="step-number">第一步</span>
                    <div class="step-content">客户进入【我的】个人中心，点击打开二维码</div>
                </div>

                <!-- 二维码示例图片 -->
                <div class="qrcode-example">
                    <img :src="checkinImg" alt="二维码示例" />
                </div>
            </div>

            <!-- 第二步 -->
            <div class="step-section">
                <div class="step-title">
                    <span class="step-number">第二步</span>
                    <div class="step-content">点击下方按钮，扫描码客户二维码后，完成所有门店活动签到</div>
                </div>
            </div>
        </div>

        <!-- 扫码按钮 -->
        <div class="scan-button-container">
            <button class="scan-button" @click="startScan">去扫码</button>
        </div>
    </div>
</template>

<script setup>
import { showToast } from 'vant'
import { useRouter } from 'vue-router'
import bar1 from '@/assets/img/checkin_tip.png'

const router = useRouter()
const checkinImg = bar1   

// 开始扫码
const startScan = () => {
  router.push("/checkinstatus")
    console.log('开始扫码');
    // 检查企业微信SDK是否可用
    if (typeof wx !== 'undefined') {
        try {
            // 调用企业微信SDK的扫码功能
            wx.scanQRCode({
                desc: '扫描客户二维码进行门店签到',
                needResult: 1, // 默认为0，扫描结果由企业微信处理，1则直接返回扫描结果
                scanType: ['qrCode'], // 仅扫描二维码
                success: function (res) {
                    console.log('扫码成功:', res.resultStr);
                    // 处理扫码结果
                    handleScanResult(res.resultStr);
                },
                fail: function (err) {
                    console.error('扫码失败:', err);
                    showToast('扫码失败，请重试');
                },
                complete: function () {
                    console.log('扫码操作完成');
                }
            });
        } catch (error) {
            console.error('调用扫码API时出错:', error);
            showToast('扫码功能暂不可用，请稍后重试');
        }
    } else {
        // 在开发环境中模拟扫码结果
        console.log('开发环境：模拟扫码成功');
        showToast('开发环境：模拟扫码成功，实际使用时将调用企业微信扫码功能');
    }
};

// 处理扫码结果
const handleScanResult = (resultStr) => {
    try {
        // 解析扫描结果
        console.log('处理扫描结果:', resultStr);

        // 这里可以添加对扫描结果的处理逻辑
        // 例如：调用后端API进行签到验证

        // 模拟签到成功
        setTimeout(() => {
            alert('签到成功！');
        }, 500);
    } catch (error) {
        console.error('处理扫描结果时出错:', error);
        showToast('解析二维码信息失败，请扫描正确的二维码');
    }
};
</script>

<style lang="less" scoped>
.shop-checkin-container {
    padding: 10px 17px;
    min-height: 100vh;
    // 步骤容器样式
    .steps-container {
        padding:0 10px 10px 10px;
        background-color: #fff;
        border-radius: 8px;
        .step-section {
            padding: 0;
            margin:0;
            .step-title {
                margin-bottom: 15px;
                .step-number {
                    display: inline-flex;
                    align-items: center;
                    font-size: 15px;
                    color: #333333;
                    font-weight: 500;
                    margin-right: 8px;

                    &::before {
                        content: '';
                        display: inline-block;
                        width: 3px;
                        border-radius: 2px;
                        height: 14px;
                        background-color: #FF7123;
                        margin-right: 8px;
                        vertical-align: middle;
                    }
                }

                .step-content {
                    font-size: 15px;
                    color: #333333;
                }
            }

            .qrcode-example {
                width: 100%;
                border-radius: 8px;
                padding:0 5px;
                img {
                    max-width: 100%;
                    height: auto;
                    border-radius: 4px;
                }
            }
        }
    }

    // 扫码按钮样式
    .scan-button-container {
        .scan-button {
            width: 100%;
            height: 46px;
            background-color: #DCBB89;
            color: #FFFFFF;
            border: none;
            border-radius: 11px;
            font-size: 19px;
            font-weight: 500;
            cursor: pointer;
            transition: background-color 0.3s;

            &:active {
                background-color: #C8A77C;
            }
        }
    }
}
</style>